import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';

function EmailVerificationPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('Verifying...');
  const [error, setError] = useState('');

  useEffect(() => {
    async function verifyEmail() {
      const token = searchParams.get('token');
      if (!token) {
        setError('No verification token found.');
        return;
      }
      try {
        const res = await fetch(`/api/myteconstruction/auth/verify?token=${token}`);
        if (!res.ok) {
          throw new Error('Verification failed or token invalid.');
        }
        setStatus('Email verified! Redirecting...');
        setTimeout(() => {
          navigate('/welcome'); // or your chosen route
        }, 2000);
      } catch (err) {
        setError(String(err));
      }
    }
    verifyEmail();
  }, [searchParams, navigate]);

  return (
    <div className="min-h-screen bg-black flex flex-col items-center justify-center text-white">
      <h1 className="text-2xl font-bold mb-4">Email Verification</h1>
      {status && !error && <p className="text-green-400">{status}</p>}
      {error && <p className="text-red-400">Error: {error}</p>}
    </div>
  );
}

export default EmailVerificationPage;
